// @ts-ignore: moment declaration file
import moment from 'moment-timezone/builds/moment-timezone-with-data-10-year-range.js'
import type { ActiveReservationCoupon } from '@/types/reservation-checkout'

export interface CheckoutPriceBreakdown {
    originalPrice: number
    finalPrice: number
    discountAmount: number
}

export interface ReservationDuration {
    days: number
    hours: number
}

export function getDisplayPriceFromCents(amountCents: number): number {
    return Number((amountCents / 100).toFixed(2))
}

export function getCzkCurrencyLabel(locale: string | null | undefined): string {
    return locale?.startsWith('cs') ? 'Kč' : 'CZK'
}

export function formatCzkAmount(
    amount: number,
    locale: string | null | undefined,
): string {
    if (locale?.startsWith('cs')) {
        return `${amount} Kč`
    }

    if (locale?.startsWith('en')) {
        return `CZK ${amount}`
    }

    return `${amount} CZK`
}

export function getReservationDuration(
    beginsAt: string,
    endsAt: string,
): ReservationDuration {
    const differenceInHours = moment(endsAt).diff(moment(beginsAt), 'hours')

    if (differenceInHours >= 24) {
        return {
            days: Math.floor(differenceInHours / 24),
            hours: differenceInHours % 24,
        }
    }

    return {
        days: 0,
        hours: differenceInHours,
    }
}

export function getCheckoutPriceBreakdown({
    amountCents,
    checkoutAmountCents,
}: {
    amountCents: number
    checkoutAmountCents: number
    coupon?: ActiveReservationCoupon | null
}): CheckoutPriceBreakdown {
    const originalPrice = getDisplayPriceFromCents(amountCents)
    const finalPrice = getDisplayPriceFromCents(checkoutAmountCents)
    const discountAmount = Number(Math.max(0, originalPrice - finalPrice).toFixed(2))

    return {
        originalPrice,
        finalPrice,
        discountAmount,
    }
}
